import React from "react";
import { HStack, Divider, Flex, Box } from "@chakra-ui/react";
import type { IHeaderProps } from "../index";
import LeftSide from "./LeftSide";
import { observer } from "mobx-react-lite";
import { useAnalytics } from "../../../hooks";

const HeaderDesktop: React.FC<IHeaderProps> = observer(({ contents }) => {
	const { addAnalyticEvent } = useAnalytics();
	const handleTriggerTagging = (description: string, step?: string): void => {
		addAnalyticEvent({
			component: "body",
			action: "click.button",
			description,
			step: step ? `fgts:menu:${step}` : "fgts:menu",
			value: "",
		}, {applySanitize: true});
	};

	return (
		<Box bg={"white"} w={"100%"} paddingBottom={"4px"}>
			<Flex direction={"column"} paddingBottom={"4px"} h={"84px"} bg={"white"} flex={1} m={"0 auto"} maxW={"1440px"}>
				<HStack justifyContent={"space-between"} flex={1} px={"108px"}>
					<LeftSide contents={contents} onTriggerTagging={handleTriggerTagging} />
				</HStack>
			</Flex>
			<Divider borderColor={"white.200"} opacity={1} />
		</Box>
	);
});

export default HeaderDesktop;
